/** @type {Partial<import("swr/dist/types").PublicConfiguration>} */
export const SWR_CONFIG_FOR_STATIC_DATA = {
  revalidateIfStale: true,
  revalidateOnMount: true,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  dedupingInterval: 0,
  refreshInterval: 0,
};
